import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import CircularProgress from 'material-ui/CircularProgress';
import colors from '@theme/colors';

const ButtonWrapper = styled.button`
  font-size: 12px;
  cursor: pointer;
  margin: 0;
  padding: 0 24px;
  width: 180px;
  height: 45px;
  outline: none;
  text-decoration: none;
  text-align: center;
  border: none;
  background-color: ${colors.WHITE};
  color: ${colors.PRIMARY};
  border: 1px solid ${colors.PRIMARY};
  border-radius: 2px;

  ${({ primary }) =>
    primary &&
    css`
      background-color: ${colors.PRIMARY};
      color: ${colors.WHITE};
    `}
  
  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${colors.LIGHT_GREY}!important;
      border: 1px solid ${colors.GREY};
      color: ${colors.GREY};
      cursor: not-allowed;
    `}
  
  ${({ success }) =>
    success &&
    css`
      background-color: ${colors.SUCCESS}!important;
      border: 1px solid ${colors.SUCCESS};
      color: ${colors.WHITE};
    `}

  ${({ danger }) =>
    danger &&
    css`
      background-color: ${colors.DANGER};
      border-color: ${colors.DANGER};
      color: ${colors.WHITE};
    `}

  ${({ big }) =>
    big &&
    css`
      font-size: 14px;
      width: 250px;
      height: 62px;
    `}

  ${({ small }) =>
    small &&
    css`
      height: 32px;
      width: 120px;
    `}

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}

  ${({ invisible }) =>
    invisible &&
    css`
      background-color: transparent;
      border: none;
      width: initial;
      height: initial;
      font-size: inherit;
      padding: 0;
    `}
`;

const Loader = ({ primary = false }) => (
  <CircularProgress
    color={primary ? colors.WHITE : colors.PRIMARY}
    size={20}
    thickness={2}
  />
);

const Button = ({ id, children, loading, ...rest }) => (
  <ButtonWrapper id={id} {...rest}>
    {loading ? <Loader {...rest} /> : children}
  </ButtonWrapper>
);

Button.propTypes = {
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool,
  primary: PropTypes.bool,
  danger: PropTypes.bool,
  big: PropTypes.bool,
  small: PropTypes.bool,
  fullWidth: PropTypes.bool,
  invisible: PropTypes.bool,
  disabled: PropTypes.bool,
};

Button.defaultTypes = {
  loading: false,
};

export default Button;



// WEBPACK FOOTER //
// ./components/atoms/Button.js